"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Columns = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var file_extension_1 = __importDefault(require("file-extension"));
var react_1 = __importDefault(require("react"));
var document_types_1 = require("../../../lib/document-types");
var associations_1 = require("../../../providers/associations");
var file_associations_1 = require("../../file-associations");
var file_status_badge_1 = require("../../file-status-badge");
var truncated_text_1 = require("../../truncated-text");
var menu_items_1 = __importDefault(require("./menu-items"));
function Columns(handleViewDetailsSheetRoute, handlePreviewEmail) {
    return [
        {
            label: 'Name',
            dataField: ' ',
            format: function (value, file) {
                var fileId = file.fileId, fileName = file.fileName, status = file.status, summary = file.summary, preview = file.preview, download = file.download, archive = file.archive, unarchive = file.unarchive, category = file.category;
                var customizedFileName = (summary || '');
                var isEmail = (category === null || category === void 0 ? void 0 : category.toLowerCase()) === 'email';
                var menu = core_ui_1.formatters.actionMenu(function (_row, toggle) { return (react_1.default.createElement(menu_items_1.default, { fileId: fileId, toggle: toggle, handleDownload: download, handleArchive: archive, handleUnarchive: unarchive, handlePreview: preview, handleEmailPreview: isEmail ? handlePreviewEmail : undefined, isArchived: status === 'ARCHIVED' })); });
                var emailExtension = (0, file_extension_1.default)(fileName || '') !== 'msg' ? 'eml' : 'msg';
                return (react_1.default.createElement(core_ui_1.Flexbox, { alignItems: "center", justifyContent: "space-between", width: "100%" },
                    react_1.default.createElement(core_ui_1.Flexbox, { alignItems: "center", width: "90%" },
                        react_1.default.createElement(core_ui_1.Padding, { right: 8 },
                            react_1.default.createElement(core_ui_1.FileExtensionBadge, { fileName: fileName, extension: isEmail ? emailExtension : undefined })),
                        react_1.default.createElement(core_ui_1.Flexbox, { flexDirection: "column", width: "100%" },
                            react_1.default.createElement(core_ui_1.Flexbox, { alignItems: "center" },
                                react_1.default.createElement(core_ui_1.TextLink, { variant: "secondary", onClick: function () { return handleViewDetailsSheetRoute(fileId); } }, fileName || '')),
                            customizedFileName && react_1.default.createElement(truncated_text_1.TruncatedText, { text: customizedFileName }))),
                    fileId && menu(value, file, false)));
            },
        },
        {
            label: 'Associations',
            dataField: 'associations',
            width: '300px',
            format: function (_value, searchResult) {
                var associations = searchResult.associations;
                if (associations === null) {
                    return react_1.default.createElement(core_ui_1.CircleSpinnerInline, null);
                }
                if (!(associations === null || associations === void 0 ? void 0 : associations.length))
                    return null;
                return react_1.default.createElement(file_associations_1.Associations, { associations: associations, includeLabel: true });
            },
        },
        {
            label: 'Status',
            dataField: 'status',
            format: function (_cell, file) {
                var status = file.status;
                return react_1.default.createElement(file_status_badge_1.FileStatusBadge, { status: status });
            },
        },
        {
            label: 'Document type',
            dataField: 'category',
            width: '200px',
            format: function (_cell, file) {
                return file.category ? (react_1.default.createElement(core_ui_1.Text, { color: "primary", truncate: true }, (0, document_types_1.standardizeDocTypes)(file.category))) : null;
            },
        },
        {
            label: 'Created on',
            dataField: 'createdAt',
            format: core_ui_1.formatters.longDateFormat,
            width: '200px',
        },
        {
            label: 'Created by',
            dataField: 'createdByUserId',
            format: function (createdByUserId, _file) {
                return (react_1.default.createElement(associations_1.AssociationsProvider, { associations: { user: [createdByUserId] } },
                    react_1.default.createElement(file_associations_1.UserAssociations, null)));
            },
        },
        {
            label: 'Updated on',
            dataField: 'updatedAt',
            format: core_ui_1.formatters.longDateFormat,
            width: '200px',
        },
        {
            label: 'Updated by',
            dataField: 'updatedByUserId',
            format: function (updatedByUserId, _file) {
                return (react_1.default.createElement(associations_1.AssociationsProvider, { associations: { user: [updatedByUserId] } },
                    react_1.default.createElement(file_associations_1.UserAssociations, null)));
            },
        },
    ];
}
exports.Columns = Columns;
